import { useState } from "react";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DefaultForm } from "../../components";
import { StatGroup} from "../../entities/enums";
import { StatInfoGroupComputeModel } from "../../entities/statInfo";
import { useGetCompaniesSelectFilterQuery } from "../../features/api/apiSlice";
import { Alert } from "antd";

interface StatInfoGroupComputerProps {
  computeCallback: (data: StatInfoGroupComputeModel) => Promise<boolean>;
}

export const StatInfoGroupComputer = ({ computeCallback }: StatInfoGroupComputerProps) => {
  const [isComputing, setIsComputing] = useState(false);

  let model: StatInfoGroupComputeModel = {
      companyId: undefined,
      group: StatGroup.None,
      computeAll: false
  };

  const onFinish = async (values: any) => {
    let computeModel: StatInfoGroupComputeModel = {
      ...values,
      companyId: values.companyId ?? 0
    };

    setIsComputing(true);

    await computeCallback(computeModel);

    setIsComputing(false);
  };

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
      <DefaultForm.DataSelect name="companyId" label="شرکت" placeholder="انتخاب شرکت" wrapperCol={{xs: 24, lg: 12}}
        query={useGetCompaniesSelectFilterQuery}
        displayText={(x) => `${x.symbol} (${x.name})`}
      />

      <DefaultForm.EnumSelect name="group" label="گروه آمار" type={StatGroup} wrapperCol={{xs: 24, lg: 12}} />
      <DefaultForm.Checkbox name="computeAll" label="محاسبه همه" />
      <DefaultForm.SubmitButton loading={isComputing} icon={<FontAwesomeIcon className="anticon" icon={faCheckDouble} />}>
          محاسبه گروهی و ذخیره
      </DefaultForm.SubmitButton>
      <Alert type="warning" className="lg:w-1/2" closable message="محاسبه گروهی اطلاعات آماری بر اساس داده های آماری موجود"/>

    </DefaultForm>
  );
};
